import { get, isNumber, map } from 'lodash';
import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import getGqlOperationName from '../../utils/getGqlOperationName';
import query from '../withProgramGroupSelector.graphql';
const useProgramGroupSelector = ({ orgGroupId, organisations, programsStatuses, withIntake, skip, }) => {
    const queryRes = useQuery(query, {
        skip: !isNumber(orgGroupId) || skip,
        variables: {
            orgGroupId,
            internalLevels: map(organisations, 'id'),
            programsStatuses,
            withIntake,
        },
    });
    const models = useMemo(() => get(queryRes, `data.${getGqlOperationName(query)}`, []), [queryRes]);
    return { models, error: queryRes.error, loading: queryRes.loading };
};
export default useProgramGroupSelector;
